export default __webpack_public_path__ + "static/media/logo-verde.15b3d360.svg";